/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_EQUIPMENTS } from '../../actions.type'
import {
  CREATE_EQUIPMENT,
  REMOVE_EQUIPMENT,
  SET_EQUIPMENT_ALL_REQUEST,
  SET_EQUIPMENT_ALL_VALUE,
  UPDATE_EQUIPMENT
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  equipmentAllValue: (state) => state.all.value,
  equipmentAllRequest: (state) => state.all.request,
  equipmentAllById: (state) => keyBy(state.all.value, 'id'),
  equipmentAllByLocationId: (state) => groupBy(state.all.value, 'location.id'),
  equipmentAllByOwnerId: (state) => groupBy(state.all.value, 'owner.id'),
  equipmentAllByContractId: (state) => groupBy(state.all.value, 'contract.id')
}

const actions = {
  async [FETCH_EQUIPMENTS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('equipment', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_EQUIPMENT_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_EQUIPMENT_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_EQUIPMENT_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_EQUIPMENT_ALL_VALUE, data)
    } catch (e) {
      commit(SET_EQUIPMENT_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_EQUIPMENT({ commit }, value) {
    commit(CREATE_EQUIPMENT, value)
  },

  async SOCKET_UPDATE_EQUIPMENT({ commit }, value) {
    commit(UPDATE_EQUIPMENT, value)
  },

  async SOCKET_REMOVE_EQUIPMENT({ commit }, id) {
    commit(REMOVE_EQUIPMENT, id)
  }
}

const mutations = {
  [SET_EQUIPMENT_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_EQUIPMENT_ALL_VALUE](state, equipments) {
    state.all.value = equipments
  },
  [UPDATE_EQUIPMENT](state, updatedEquipment) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedEquipment.id }),
      1,
      updatedEquipment
    )
  },
  [CREATE_EQUIPMENT](state, createdEquipment) {
    state.all.value.push(createdEquipment)
  },
  [REMOVE_EQUIPMENT](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
